import React, { Component } from 'react';
import { connect } from 'react-redux';

import Chip from 'material-ui/Chip';
import PostApi from '../../Logicas/PostApi';
import * as PostApiAsync from '../../Logicas/PostApiAsync';
import { browserHistory } from 'react-router';

import DownloadPostData from '../_shared/DownloadPostData/DownloadPostData';
import { BodyTable } from '../utils/BodyTable';
import DialogApi from '../../Logicas/DialogApi';
import ComponentHeader from '../utils/ComponenteHeader';
import { DialogYesNo } from '../utils/DailogComponentes';
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableData,
  RemoveEdit,
  TableHeadRow
} from '../utils/Table';
import Pagination from '../utils/AutoPagination/Pagination';
import Loader from '../utils/AutoPagination/Loader';
import UserApi from '../../Logicas/UserApi';

import not_img from '../utils/img/ico-external.png';
import { FooterPagination } from '../utils/Pagination';
import { style } from '../../style';

class FormList extends Component {
  constructor() {
    super();
    this.redirectNewForm = this.redirectNewForm.bind(this);
  }

  componentWillMount() {
    !this.props.list.publications && this.props.getPostList('form');
    if(sessionStorage.getItem("@Noz-hasMoodSurvey") === null)
      this.props.getMoodSurveyFromProfileAPI();
    else
      this.props.setMoodSurveyFromState(
        sessionStorage.getItem("@Noz-hasMoodSurvey") === "true" ? true : false
      )
  }

  redirectNewForm() {
    this.props.getTypeForm(true);
    this.props.setTypeDraw();
    browserHistory.push('/post/create');
  }

  render() {
    const { listRequestsActive } = this.props;
    if (this.props.list) {
      return (
        <div>
          <ComponentHeader
            onClick={this.redirectNewForm}
            tooltip={
              <p>
                Atualizar formulário
                <br />
              </p>
            }
            actions={
              this.props.hasMoodSurveyActive
                ? [
                    {
                      name: 'Enquetes',
                      action: this.props.getSurveyPublication
                    },
                    {
                      name: 'Publicações',
                      action: () => this.props.getPostList('publication')
                    },
                    {
                      name: 'Sorteios',
                      action: () => this.props.getPostList('draw', 'raffle')
                    },
                    {
                      name: 'Termômetro de humor',
                      action: () => this.props.getMoodSurveys(),
                      style: { width: '11rem', textAlign: 'center' }
                    },
                    {
                      name: 'Rascunhos',
                      action: this.props.getDraftPublication
                    }
                  ]
                : [
                    {
                      name: 'Enquetes',
                      action: this.props.getSurveyPublication
                    },
                    {
                      name: 'Publicações',
                      action: () => this.props.getPostList('publication')
                    },
                    {
                      name: 'Sorteios',
                      action: () => this.props.getPostList('draw', 'raffle')
                    },
                    {
                      name: 'Rascunhos',
                      action: this.props.getDraftPublication
                    }
                  ]
            }
            name="Formulários"
            nameaction="Novo formulário"
            withMoodSurvey
            enablesubmit={listRequestsActive.length > 0}
          />
          <DownloadPostData kind="form" />
          <BodyTable>
            <Table>
              <TableHead>
                <TableHeadRow>Id</TableHeadRow>
                <TableHeadRow>Publicação</TableHeadRow>
                <TableHeadRow></TableHeadRow>
                <TableHeadRow>Tags</TableHeadRow>
                <TableHeadRow></TableHeadRow>
                <TableHeadRow>Visualizações</TableHeadRow>
                <TableHeadRow>Comentários</TableHeadRow>
                <TableHeadRow>Data</TableHeadRow>
                <TableHeadRow>Ações</TableHeadRow>
              </TableHead>

              <TableBody>
                {this.props.list.publications &&
                  this.props.list.publications.map(
                    function(publication, i) {
                      return (
                        <TableRow key={i} onClik={this.props.editUser}>
                          <TableData>
                            <div
                              style={{
                                marginTop: '30px'
                              }}
                            >
                              {publication.id}
                            </div>
                          </TableData>
                          <TableData>
                            <div>
                              {publication.cover ? (
                                publication.cover.kind === 'video' ? (
                                  <video
                                    src={publication.cover.url}
                                    style={{
                                      width: '100px',
                                      height: '60px',
                                      'object-fit': 'cover'
                                    }}
                                    width="100%"
                                    preload
                                    loop
                                    muted
                                    controls
                                    controlsList="nodownload"
                                    alt="conteúdo de vídeo"
                                  />
                                ) : (
                                  <img
                                    src={
                                      publication.cover.url
                                        ? publication.cover.url
                                        : not_img
                                    }
                                    style={{
                                      width: '100px',
                                      height: '60px',
                                      'object-fit': 'cover'
                                    }}
                                    alt="Capa da publicação"
                                  />
                                )
                              ) : (
                                <img
                                  src={not_img}
                                  style={{
                                    width: '100px',
                                    height: '60px',
                                    'object-fit': 'cover'
                                  }}
                                  alt="Ícone de publicação sem capa"
                                />
                              )}
                            </div>
                          </TableData>
                          <TableData>
                            <div
                              style={{
                                marginTop: '30px'
                              }}
                            >
                              {publication.title.length > 30
                                ? publication.title.slice(0, 30) + '...'
                                : publication.title}
                            </div>
                          </TableData>
                          <TableData>
                            <div className="tags">
                              <Chip>
                                {publication.tags.length > 0
                                  ? publication.tags[0].name.length > 30
                                    ? publication.tags[0].name.substring(
                                        0,
                                        20
                                      ) + '...'
                                    : publication.tags[0].name
                                  : null}
                              </Chip>
                              {publication.tags.length > 1 && (
                                <Chip>{publication.tags.length - 1}</Chip>
                              )}
                            </div>
                          </TableData>
                          <TableData>
                            <div
                              style={{
                                marginTop: '15px'
                              }}
                            >
                              <Chip> {publication.tag_main}</Chip>
                            </div>
                          </TableData>
                          <TableData>
                            <div
                              style={{
                                marginTop: '30px'
                              }}
                            >
                              {publication.visualization}
                            </div>
                          </TableData>
                          <TableData>
                            <div
                              style={{
                                marginTop: '30px'
                              }}
                            >
                              {publication.comments}
                            </div>
                          </TableData>

                          <TableData>
                            <div
                              style={{
                                marginTop: '30px'
                              }}
                            >
                              {publication.created_at === 'Invalid date'
                                ? 'Aguardando publicação'
                                : publication.created_at}
                            </div>
                            <br />
                            <label>{publication.user_name}</label>
                          </TableData>
                          <TableData>
                            <div
                              style={{
                                marginTop: '20px'
                              }}
                            >
                              <RemoveEdit
                                Delete={this.props.deleteShowDialogPublication.bind(
                                  this,
                                  publication.id,
                                  publication.is_publication
                                )}
                                Edition={() => {
                                  this.props.editPost(publication.id);
                                  this.props.setNotificationShow();
                                }}
                                edit={false}
                                View={this.props.getViewForm.bind(
                                  this,
                                  publication.id,
                                  publication.is_publication
                                )}
                                enablesubmit={listRequestsActive.length > 0}
                              />
                            </div>
                          </TableData>
                        </TableRow>
                      );
                    }.bind(this)
                  )}
              </TableBody>
            </Table>
            {this.props.list.size > 0 && (
              <footer className="footer-pagination">
                <FooterPagination
                  activePage={this.props.page}
                  totalItemsCount={this.props.list.size}
                  handlePageChange={(pageNumber) =>
                    this.props.getMorePublications(pageNumber)
                  }
                />
              </footer>
            )}
          </BodyTable>
          <Loader loading={this.props.loading} />
          <DialogYesNo
            yesclick={this.props.deletePost.bind(
              this,
              this.props.alert.id_elemente,
              this.props.alert.is_publication
            )}
            noclick={this.props.closeDialog}
            onClick={this.props.closeDialog}
            visible={this.props.alert.visible}
            message="Tem certeza que deseja remover esta publicação ?"
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    list: state.post.list,
    page: state.post.page,
    alert: state.dialog,
    pagination: state.post.pagination,
    loading: state.progress_indeterminate,
    listRequestsActive: state.post.listRequestsActive,
    hasMoodSurveyActive: state.user.hasMoodSurveyActive,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPostList: (kind, raffle = '') => {
      dispatch(PostApi.getPostListV2(kind, raffle));
    },
    getMorePublications: (page, kind, raffle) => {
      dispatch(PostApiAsync.getMorePublications(page, 'form', ''));
    },
    deleteShowDialogPublication: (id, values) => {
      dispatch(DialogApi.deleteAlert(id));
    },
    editPost: (id) => {
      dispatch(PostApi.editPost(id));
    },
    getViewForm: (id) => {
      dispatch(PostApi.getViewForm(id));
    },
    closeDialog: () => {
      dispatch(DialogApi.closeDialog());
    },
    deletePost: (id, values) => {
      dispatch(PostApi.deletePost(id, values, true));
    },
    getDraftPublication: () => {
      dispatch(PostApi.getPostListDraft());
    },
    getSurveyPublication: () => {
      dispatch(PostApi.getSurveyList(1));
    },
    getMoodSurveys: (page = 1, active) => {
      dispatch(PostApi.getMoodSurveys(page, active));
    },
    getTypeForm: (isForm) => {
      dispatch(PostApi.getTypeForm(isForm));
    },
    setNotificationShow: () => {
      dispatch({ type: 'ENABLE_NOTIFICATION_SHOW' });
    },
    setTypeDraw: () => {
      dispatch({ type: 'GET_TYPE_DRAW', isDrawType: false });
    },
    getMoodSurveyFromProfileAPI: () => {
      dispatch(UserApi.getMoodSurveyFromProfileAPI());
    },
    setMoodSurveyFromState: (hasMoodSurveyActive) => {
      dispatch({
        type: 'SET_MOOD_SURVEY_ACTIVE',
        hasMoodSurveyActive,
      });
    }
  };
};

const FormListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormList);

export default FormListContainer;
